import { useQuery } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_TABLES_REPAIR_TYPES_PATH } from '@/services'

export const useGetServiceBookingRepairTypes = (tokenId, config = {}) => {
  const api = useLegacyPublicApi()

  return useQuery({
    queryKey: ['get-table-service-booking-repair-types', tokenId],
    queryFn: async () => {
      if (!api || !tokenId) {
        return false
      }
      const { data } = await api.get(
        SERVICE_BOOKING_TABLES_REPAIR_TYPES_PATH.replace('{tokenId}', tokenId),
      )
      return data
    },
    ...config,
  })
}
